import { render, staticRenderFns } from "./cp_config_edit.vue?vue&type=template&id=6c647c7d&"
import script from "./cp_config_edit.vue?vue&type=script&lang=js&"
export * from "./cp_config_edit.vue?vue&type=script&lang=js&"
import style0 from "./cp_config_edit.vue?vue&type=style&index=0&id=6c647c7d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports